import { TextField, type TextFieldProps } from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

type TextInputProps = TextFieldProps & {
  label: string;
  required?: boolean;
};

const TextInput = ({ label, required = false, ...props }: TextInputProps) => {
  const field = useFieldContext<string>();

  const isValid = field.state.meta.errors.length === 0;
  const errors = field.state.meta.errors.map((err) => err?.message);

  return (
    <TextField
      value={field.state.value ?? ""}
      onChange={(e) => field.handleChange(e.target.value)}
      id={`text-input-${label}`}
      label={label}
      variant="outlined"
      size="small"
      fullWidth
      error={!isValid}
      required={required}
      {...props}
      helperText={errors.join(", ") || props.helperText}
    />
  );
};

export default TextInput;
